<script setup>
import { NFlex } from 'naive-ui';
import { computed } from 'vue';

import folder01 from '@/assets/images/result/folder_01.png';
import folder02 from '@/assets/images/result/folder_02.png';
import folder03 from '@/assets/images/result/folder_03.png'; 

const helperResources = computed(() => [
  {
    category: '초등',
    icon: folder01, 
    primaryColor: '#DE6413',
    title: '문해력·수리력 통합 수업활동 자료',
    descriptions: [
      '초3·4 교실에서 만나는 문해력·수리력',
      '초5·6 교실에서 만나는 문해력·수리력',
      '초등 문해력 수업 이야기',
      '초등(3·4) 수리력 한 걸음',
      '초등 수리력 성장 나침반'
    ]
  },
  {
    category: '중등',
    icon: folder02, 
    primaryColor: '#1A951E',
    title: '교과서를 넘어 실생활로, 수리력 수업 디자인', 
    descriptions: [
      '중·고 연계형 수학과 학생 맞춤형 지도자료(고1 성취기준을 중심으로)'
    ]
  },
  {
    category: '공통',
    icon: folder03, 
    primaryColor: '#005BAC',
    title: '초·중·고 독서기반 문해력 향상 자료집 「북돋움」',
    descriptions: [
      '문해력 향상을 위한 읽기 지도 교재 토닥토닥 읽기 코칭(하늘, 바람, 별)'
    ]
  }
]);

// PDF로 저장해도 눌러서 열 수 있게 a 태그로 넣는다 (pdfDownloader 가 a[href] 를 PDF 링크로 변환)
const downloadUrl = 'https://buly.kr/7QP1MVZ';

// 왼쪽 칸은 초등, 오른쪽 칸은 중등·공통
const leftResources = computed(() => helperResources.value.filter((item) => item.category === '초등'));
const rightResources = computed(() => helperResources.value.filter((item) => item.category !== '초등'));
</script>

<template>
  <div class="helper">
    <p class="title-row text-[24px] pb-5 font-semibold">
      <span>문해력·수리력 신장 수업 도움 자료</span>
      <a class="go-link" :href="downloadUrl" target="_blank" rel="noopener">바로가기 <span class="arrow">&gt;</span></a>
    </p>
    <div class="columns">
      <ul v-for="(group, gIndex) in [leftResources, rightResources]" :key="gIndex">
        <li v-for="(item, index) in group" :key="index" :style="{ '--item-primary-color': item.primaryColor}">
          <div class="icon-wrap" :style="{ backgroundImage: `url(${item.icon})` }">
            <span class="text-[20px] font-medium">{{ item.category }}</span>
          </div>
          <div class="text-wrap">
            <p>{{ item.title }}</p>
            <p v-for="(desc, dIndex) in item.descriptions" :key="dIndex">{{ desc }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.helper {    
  width: 100%;
    .title-row {
        display: flex;
        align-items: center; // 버튼이 제목 글자와 같은 선상에 오게
        gap: 12px;
        // 리터러시 결과지(AiSuggestionList)의 '바로가기' 버튼과 같은 모양.
        // PDF 에서도 눌러서 열 수 있다(pdfDownloader 가 a[href] 를 PDF 링크로 변환)
        .go-link {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 3px 12px;
            border: 1px solid var(--result-light-red);
            border-radius: 6px;
            background: #fff;
            color: var(--result-light-red);
            font-size: 14px;
            font-weight: 600;
            line-height: 1.6;
            text-decoration: none;
            white-space: nowrap;
            .arrow { font-size: 13px; }
        }
    }
    .columns {
        display: flex;
        gap: 40px;
        align-items: flex-start;
        > ul { flex: 1; min-width: 0; }
        > ul > li:first-child {
            border-top: none;
            padding-top: 0;
        }
    }
    ul {
        li {
            display: flex;
            gap: 20px;    
            padding: 16px 0;
            border-top: 2px dashed #ccc;   
            .icon-wrap {
                width: 74px;
                height: 60px;
                flex: 0 0 74px; // 2단에서 칸이 좁아져도 아이콘이 줄어 잘리지 않게
                background-size: 74px 60px;
                background-repeat: no-repeat;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 20px;
                padding-right: 15px;
            }
            .text-wrap {
                // 제목·자료명 모두 분류별 대표색으로 표시한다 (예전에는 홀수 줄만 색, 짝수 줄은 회색)
                p {
                    padding-left: 20px;
                    font-size: 20px;
                    font-weight: 500;
                    color: var(--item-primary-color);    
                    position: relative;      
                    line-height: 1.5;     
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;   
                        width: 5px;
                        height: 5px;
                        border-radius: 100%;         
                        // 여러 줄이어도 점은 첫 줄 높이에 맞춘다 (줄높이 1.5 의 절반 - 점 반지름)
                        top: 0.625em;
                        background-color: var(--item-primary-color); 
                    }
                }    
            }
           /*  &:nth-child(1) .text-wrap p:nth-child(2) {padding-bottom: 5px; }*/
        }
    }    
}
</style>